import React from 'react';
import PropTypes from 'prop-types';

import { LocaleService } from '@sm360/widget-commons-core-services';
import MetaDataModel from 'inventory-listing/models/MetaDataModel.js';
import FilterRange from 'inventory-listing/components/ListingFilters/Components/FilterRange/FilterRange.jsx';
import FilterRangeService from 'inventory-listing/components/ListingFilters/Components/FilterRange/FilterRangeService/FilterRangeService.js';

import { DEFAULT_STEP, DEFAULT_MIN, DEFAULT_MAX, URL_PARAMETER_MIN, URL_PARAMETER_MAX } from './constants.js';

class ListingFiltersYearsRange extends React.Component {
    constructor(props) {
        super(props);

        this.handleSelectedValue = this.handleSelectedValue.bind(this);
        this.updateQuery = this.updateQuery.bind(this);

        this.state = FilterRangeService.getInitState({
            metadataCategorie: props.years,
            URL_PARAMETER_MIN,
            URL_PARAMETER_MAX,
            DEFAULT_MIN,
            DEFAULT_MAX,
            DEFAULT_STEP,
            contextYear: props.contextYear,
        });
    }

    componentWillReceiveProps(nextProps) {
        const initState = FilterRangeService.getInitState({
            metadataCategorie: nextProps.years,
            URL_PARAMETER_MIN,
            URL_PARAMETER_MAX,
            DEFAULT_MIN,
            DEFAULT_MAX,
            DEFAULT_STEP,
            contextYear: nextProps.contextYear,
        });
        this.setState(initState);
    }

    handleSelectedValue(selectedMin, selectedMax) {
        this.setState({
            selectedMin,
            selectedMax,
        });
    }

    updateQuery(selectedMin, selectedMax) {
        this.props.updateVehicleCriteria(
            {
                type: 'CLOSED',
                from: selectedMin,
                to: selectedMax,
            },
            'yearRange',
            true
        );
    }

    render() {
        return (
            <FilterRange
                title={LocaleService.t('FILTERS.YEARS')}
                extremeMin={this.state.extremeMin}
                extremeMax={this.state.extremeMax}
                defaultMin={this.state.selectedMin}
                defaultMax={this.state.selectedMax}
                step={DEFAULT_STEP}
                labelMin={String(this.state.selectedMin)}
                labelMax={String(this.state.selectedMax)}
                updateQuery={this.updateQuery}
                handleSelectedValue={this.handleSelectedValue}
            />
        );
    }
}

ListingFiltersYearsRange.defaultProps = {
    years: [],
    contextYear: undefined,
};

ListingFiltersYearsRange.propTypes = {
    years: PropTypes.arrayOf(PropTypes.instanceOf(MetaDataModel)),
    contextYear: PropTypes.oneOf([PropTypes.number, PropTypes.undefined]),
    updateVehicleCriteria: PropTypes.func.isRequired,
};

ListingFiltersYearsRange.displayName = 'ListingFiltersYearsRange';

export default ListingFiltersYearsRange;
